import { Types } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { DwellTimeline } from '../../types'
import dwellTimeline, { DwellTimelineOutput } from '../../utils/dwellTimeline'

/**
 * WFH Sessions timeline reducer
 */
const wfhSessionsTimeline = buildAsyncStatReducer({
    key: Metrics.WFH_SESSIONS_TIMELINE,
    types: {
        request: Types.DASHBOARD_WFH_SESSIONSTIMELINE.request,
        success: Types.DASHBOARD_WFH_SESSIONSTIMELINE.success,
        failure: Types.DASHBOARD_WFH_SESSIONSTIMELINE.failure,
    },
    transform: (state, { payload = {} }): DwellTimelineOutput => {
        const keys: string[] = Object.keys(payload)
        const data: DwellTimeline = keys.reduce((carry: DwellTimeline, date: string): DwellTimeline => {
            return [
                ...carry,
                {
                    moment: date as string,
                    time: payload[date] as number,
                },
            ] as DwellTimeline
        }, [] as DwellTimeline)

        return dwellTimeline(data)
    },
})

export default wfhSessionsTimeline
